import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
const BIG_SCREEN_PADDING = 70;
const BIG_SCREEN_MAX_WIDTH = MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH - BIG_SCREEN_PADDING;
const MEDIUM_SCREEN_PADDING_TOP_BOTTOM = 70;
export const StylesPlainClassicTestimonialsComponent = styled.div`
  max-width: ${BIG_SCREEN_MAX_WIDTH}px;
  margin: auto;
  padding-left: ${BIG_SCREEN_PADDING}px;
  padding-right: ${BIG_SCREEN_PADDING}px;

  .testimonial-card-wrapper {
    height: 100%;
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    max-width: 100vw;
    padding: ${MEDIUM_SCREEN_PADDING_TOP_BOTTOM}px 0;
  }
`;
